export enum EnvironmentType {
    PROD = "prod",
    STAGING = "staging",
}
export enum LocalEnvironmentName {
    LOCAL = "local",
    LOCAL2 = "local2",
}
export enum EnvironmentName {
    PROD = "prod",
    ALPHA = "alpha",
    BETA = "beta",
    CHI = "chi",
    DELTA = "delta",
    EPSILON = "epsilon",
    FAKER = "faker",
    GAMMA = "gamma",
    IOTA = "iota",
    KAPPA = "kappa",
    LAMBDA = "lambda",
    MU = "mu",
    NU = "nu",
    OMEGA = "omega",
    OMICRON = "omicron",
    PSI = "psi",
    RHO = "rho",
    SIGMA = "sigma",
    THETA = "theta",
    ZETA = "zeta",
    UMI = "umi",
    HADES = "hades",
    VOLDEMORT = "voldemort",
}
export type AllEnvironmentName = EnvironmentName | LocalEnvironmentName;
export type StagingEnvironmentName = Exclude<AllEnvironmentName, LocalEnvironmentName | EnvironmentName.PROD>;
export function isLocalEnvironmentName(str: string): str is LocalEnvironmentName {
    return Object.values(LocalEnvironmentName).includes(str as LocalEnvironmentName);
}
export function isEnvironmentName(str: string): str is EnvironmentName {
    return Object.values(EnvironmentName).includes(str as EnvironmentName);
}
export function isStagingEnvironment(envName: AllEnvironmentName): envName is StagingEnvironmentName {
    return envName && isEnvironmentName(envName) && envName !== EnvironmentName.PROD;
}
export function getStagingEnvironments() {
    return Object.values(EnvironmentName).filter(isStagingEnvironment);
}
export const STAGING_ENVIRONMENTS = Object.values(EnvironmentName).filter(isStagingEnvironment);
export enum StargateEnvironmentHost {
    PROD = "stargate.prod.aws.waalaxy.com",
    ALPHA = "alpha-stargate.herokuapp.com",
    BETA = "beta-stargate.herokuapp.com",
    CHI = "chi-stargate.herokuapp.com",
    DELTA = "delta-stargate.herokuapp.com",
    EPSILON = "epsilon-stargate.herokuapp.com",
    FAKER = "faker-stargate-6e0c42aadbf8.herokuapp.com",
    GAMMA = "gamma-stargate.herokuapp.com",
    IOTA = "iota-stargate.herokuapp.com",
    KAPPA = "kappa-stargate.herokuapp.com",
    LAMBDA = "lambda-stargate.herokuapp.com",
    LOCAL = "localhost:5000",
    LOCAL2 = "127.0.0.1:5000",
    MU = "mu-stargate.herokuapp.com",
    NU = "nu-stargate.herokuapp.com",
    OMEGA = "omega-stargate.herokuapp.com",
    OMICRON = "omicron-stargate-85115e3a8353.herokuapp.com",
    PSI = "psi-stargate.herokuapp.com",
    RHO = "rho-stargate.herokuapp.com",
    SIGMA = "sigma-stargate.herokuapp.com",
    STAGING = "staging-stargate.herokuapp.com",
    THETA = "theta-stargate.herokuapp.com",
    ZETA = "zeta-stargate.herokuapp.com",
    UMI = "umi-stargate-71d32dd84d9a.herokuapp.com",
    HADES = "hades-stargate-da7b30994215.herokuapp.com",
    VOLDEMORT = "voldemort-stargate-ba25b3b9d0dd.herokuapp.com",
}
export enum OttoEnvironmentHost {
    PROD = "otto.prod.aws.waalaxy.com",
    ALPHA = "alpha-otto.herokuapp.com",
    BETA = "beta-otto.herokuapp.com",
    CHI = "chi-otto.herokuapp.com",
    DELTA = "delta-otto.herokuapp.com",
    EPSILON = "epsilon-otto.herokuapp.com",
    FAKER = "faker-otto-03194d744e23.herokuapp.com",
    GAMMA = "gamma-otto.herokuapp.com",
    HADES = "hades-otto-2e56b0c496db.herokuapp.com",
    IOTA = "iota-otto.herokuapp.com",
    KAPPA = "kappa-otto.herokuapp.com",
    LAMBDA = "lambda-otto.herokuapp.com",
    MU = "mu-otto.herokuapp.com",
    NU = "nu-otto.herokuapp.com",
    OMEGA = "omega-otto.herokuapp.com",
    OMICRON = "omicron-otto-8f35c7391eda.herokuapp.com",
    PSI = "psi-otto.herokuapp.com",
    RHO = "rho-otto.herokuapp.com",
    SIGMA = "sigma-otto.herokuapp.com",
    THETA = "theta-otto.herokuapp.com",
    UMI = "umi-otto-d6fe77ebf6b7.herokuapp.com",
    VOLDEMORT = "voldemort-otto-db8791198e11.herokuapp.com",
    ZETA = "zeta-otto.herokuapp.com",
}
export enum MystiqueEnvironmentHost {
    PROD = "app.waalaxy.com",
    ALPHA = "alpha-mystique.herokuapp.com",
    BETA = "beta-mystique.herokuapp.com",
    CHI = "chi-mystique.herokuapp.com",
    DELTA = "delta-mystique.herokuapp.com",
    EPSILON = "epsilon-mystique.herokuapp.com",
    FAKER = "faker-mystique-ed95cc6e4b08.herokuapp.com",
    GAMMA = "gamma-mystique.herokuapp.com",
    IOTA = "iota-mystique.herokuapp.com",
    KAPPA = "kappa-mystique.herokuapp.com",
    LAMBDA = "lambda-mystique.herokuapp.com",
    LOCAL = "localhost:3000",
    LOCAL2 = "127.0.0.1:3000",
    MU = "mu-mystique.herokuapp.com",
    NU = "nu-mystique.herokuapp.com",
    OMEGA = "omega-mystique.herokuapp.com",
    OMICRON = "omicron-mystique-3ff9a2f52f26.herokuapp.com",
    PSI = "psi-mystique.herokuapp.com",
    RHO = "rho-mystique.herokuapp.com",
    SIGMA = "sigma-mystique.herokuapp.com",
    THETA = "theta-mystique.herokuapp.com",
    ZETA = "zeta-mystique.herokuapp.com",
    UMI = "umi-mystique-2945a8a0147d.herokuapp.com",
    HADES = "hades-mystique-e6ed216cd0fd.herokuapp.com",
    VOLDEMORT = "voldemort-mystique-fc436e385c5f.herokuapp.com",
}
export enum LifelineFrontEnvironmentHost {
    PROD = "lifeline.waalaxy.com",
    ALPHA = "alpha-lifeline-front.herokuapp.com",
    BETA = "beta-lifeline-front.herokuapp.com",
    CHI = "chi-lifeline-front.herokuapp.com",
    DELTA = "delta-lifeline-front.herokuapp.com",
    EPSILON = "epsilon-lifeline-front.herokuapp.com",
    FAKER = "faker-lifeline-front-4500876fe776.herokuapp.com",
    GAMMA = "gamma-lifeline-front.herokuapp.com",
    IOTA = "iota-lifeline-front.herokuapp.com",
    KAPPA = "kappa-lifeline-front.herokuapp.com",
    LAMBDA = "lambda-lifeline-front.herokuapp.com",
    LOCAL = "localhost:3000",
    LOCAL2 = "127.0.0.1:3000",
    MU = "mu-lifeline-front.herokuapp.com",
    NU = "nu-lifeline-front.herokuapp.com",
    OMEGA = "omega-lifeline-front.herokuapp.com",
    OMICRON = "omicron-lifeline-front-7cd3a48b275b.herokuapp.com",
    PSI = "psi-lifeline-front.herokuapp.com",
    RHO = "rho-lifeline-front.herokuapp.com",
    SIGMA = "sigma-lifeline-front.herokuapp.com",
    THETA = "theta-lifeline-front.herokuapp.com",
    ZETA = "zeta-lifeline-front.herokuapp.com",
    UMI = "umi-lifeline-front-9d73acb379d5.herokuapp.com",
    HADES = "hades-lifeline-front-e6c7b22fc46d.herokuapp.com",
    VOLDEMORT = "voldemort-lifeline-front-b554107e87b6.herokuapp.com",
}
export enum LifelineApiURL {
    PROD = "https://lifeline-back.prod.aws.waalaxy.com",
    ALPHA = "https://alpha-lifeline-back.herokuapp.com",
    BETA = "https://beta-lifeline-back.herokuapp.com",
    CHI = "https://chi-lifeline-back.herokuapp.com",
    DELTA = "https://delta-lifeline-back.herokuapp.com",
    EPSILON = "https://epsilon-lifeline-back.herokuapp.com",
    FAKER = "https://faker-lifeline-back-6593ccced273.herokuapp.com",
    GAMMA = "https://gamma-lifeline-back.herokuapp.com/",
    IOTA = "https://iota-lifeline-back.herokuapp.com",
    KAPPA = "https://kappa-lifeline-back.herokuapp.com",
    LAMBDA = "https://lambda-lifeline-back.herokuapp.com/",
    LOCAL = "https://revenant-lifeline.herokuapp.com/",
    MU = "https://mu-lifeline-back.herokuapp.com",
    NU = "https://nu-lifeline-back.herokuapp.com/",
    OMEGA = "https://omega-lifeline-back.herokuapp.com",
    OMICRON = "https://omicron-lifeline-back-7e32da17a28e.herokuapp.com/",
    PSI = "https://psi-lifeline-back.herokuapp.com",
    RHO = "https://rho-lifeline-back.herokuapp.com/",
    SIGMA = "https://sigma-lifeline-back.herokuapp.com",
    THETA = "https://theta-lifeline-back.herokuapp.com",
    ZETA = "https://zeta-lifeline-back.herokuapp.com/",
    UMI = "https://umi-lifeline-back-50fa06983a09.herokuapp.com/",
    HADES = "https://hades-lifeline-back-a694f9fa6b8e.herokuapp.com/",
    VOLDEMORT = "https://voldemort-lifeline-back-0e8e96167346.herokuapp.com/",
}
export enum FelindraApiURL {
    PROD = "https://felindra.prod.aws.waalaxy.com",
    ALPHA = "https://alpha-felindra-back.herokuapp.com",
    BETA = "https://beta-felindra-back.herokuapp.com",
    CHI = "https://chi-felindra-back.herokuapp.com",
    DELTA = "https://delta-felindra-back.herokuapp.com",
    EPSILON = "https://epsilon-felindra-back.herokuapp.com",
    FAKER = "https://faker-felindra-back-35dcd5f67f92.herokuapp.com",
    GAMMA = "https://gamma-felindra-back.herokuapp.com/",
    IOTA = "https://iota-felindra-back.herokuapp.com",
    KAPPA = "https://kappa-felindra-back.herokuapp.com",
    LAMBDA = "https://lambda-felindra-back.herokuapp.com/",
    LOCAL = "https://felindra-revenant.herokuapp.com/",
    MU = "https://mu-felindra-back.herokuapp.com",
    NU = "https://nu-felindra-back.herokuapp.com/",
    OMEGA = "https://omega-felindra-back.herokuapp.com",
    OMICRON = "https://omicron-felindra-back-d07e405eae1f.herokuapp.com/",
    PSI = "https://psi-felindra-back.herokuapp.com",
    RHO = "https://rho-felindra-back.herokuapp.com/",
    SIGMA = "https://sigma-felindra-back.herokuapp.com",
    THETA = "https://theta-felindra-back.herokuapp.com",
    ZETA = "https://zeta-felindra-back.herokuapp.com/",
    UMI = "https://umi-felindra-back-3c014e715ec2.herokuapp.com/",
    HADES = "https://hades-felindra-back-0a3c889c7c9a.herokuapp.com/",
    VOLDEMORT = "https://voldemort-felindra-back-a930b066227c.herokuapp.com/",
}
export const PALPATINE_FRONT_URL_FROM_ENVIRONMENT_NAME: Record<EnvironmentName, string> = {
    [EnvironmentName.PROD]: "https://ambassadors.waalaxy.com",
    [EnvironmentName.ALPHA]: "https://alpha-palpatine-front.herokuapp.com",
    [EnvironmentName.BETA]: "https://beta-palpatine-front.herokuapp.com",
    [EnvironmentName.CHI]: "https://chi-palpatine-front.herokuapp.com",
    [EnvironmentName.DELTA]: "https://delta-palpatine-front.herokuapp.com",
    [EnvironmentName.EPSILON]: "https://epsilon-palpatine-front.herokuapp.com",
    [EnvironmentName.FAKER]: "https://faker-palpatine-front-43b0f591ef2f.herokuapp.com",
    [EnvironmentName.GAMMA]: "https://gamma-palpatine-front.herokuapp.com/",
    [EnvironmentName.IOTA]: "https://iota-palpatine-front.herokuapp.com",
    [EnvironmentName.KAPPA]: "https://kappa-palpatine-front.herokuapp.com",
    [EnvironmentName.LAMBDA]: "https://lambda-palpatine-front.herokuapp.com/",
    [EnvironmentName.MU]: "https://mu-palpatine-front.herokuapp.com",
    [EnvironmentName.NU]: "https://nu-palpatine-front.herokuapp.com/",
    [EnvironmentName.OMEGA]: "https://omega-palpatine-front.herokuapp.com",
    [EnvironmentName.OMICRON]: "https://omicron-palpatine-front-830424653c2c.herokuapp.com/",
    [EnvironmentName.PSI]: "https://psi-palpatine-front.herokuapp.com",
    [EnvironmentName.RHO]: "https://rho-palpatine-front.herokuapp.com/",
    [EnvironmentName.SIGMA]: "https://sigma-palpatine-front.herokuapp.com",
    [EnvironmentName.THETA]: "https://theta-palpatine-front.herokuapp.com",
    [EnvironmentName.ZETA]: "https://zeta-palpatine-front.herokuapp.com/",
    [EnvironmentName.UMI]: "https://umi-palpatine-front-aacb7cb8b073.herokuapp.com/",
    [EnvironmentName.HADES]: "https://hades-palpatine-front-abcadc8f37b8.herokuapp.com/",
    [EnvironmentName.VOLDEMORT]: "https://voldemort-palpatine-front-bb42b63b8a77.herokuapp.com/",
};
export const PALPATINE_BACK_HOSTS: Record<EnvironmentName, string> = {
    [EnvironmentName.PROD]: "https://palpatine-back.prod.aws.waalaxy.com/",
    [EnvironmentName.ALPHA]: "https://alpha-palpatine-back.herokuapp.com/",
    [EnvironmentName.BETA]: "https://beta-palpatine-back.herokuapp.com/",
    [EnvironmentName.CHI]: "https://chi-palpatine-back.herokuapp.com/",
    [EnvironmentName.DELTA]: "https://delta-palpatine-back.herokuapp.com/",
    [EnvironmentName.EPSILON]: "https://epsilon-palpatine-back.herokuapp.com/",
    [EnvironmentName.FAKER]: "https://faker-palpatine-back-6f31ab835e5f.herokuapp.com/",
    [EnvironmentName.GAMMA]: "https://gamma-palpatine-back.herokuapp.com/",
    [EnvironmentName.IOTA]: "https://iota-palpatine-back.herokuapp.com/",
    [EnvironmentName.KAPPA]: "https://kappa-palpatine-back.herokuapp.com/",
    [EnvironmentName.LAMBDA]: "https://lambda-palpatine-back.herokuapp.com/",
    [EnvironmentName.MU]: "https://mu-palpatine-back.herokuapp.com/",
    [EnvironmentName.NU]: "https://nu-palpatine-back.herokuapp.com/",
    [EnvironmentName.OMEGA]: "https://omega-palpatine-back.herokuapp.com/",
    [EnvironmentName.OMICRON]: "https://omicron-palpatine-back-7233ea33bda1.herokuapp.com/",
    [EnvironmentName.PSI]: "https://psi-palpatine-back.herokuapp.com/",
    [EnvironmentName.RHO]: "https://rho-palpatine-back.herokuapp.com/",
    [EnvironmentName.SIGMA]: "https://sigma-palpatine-back.herokuapp.com/",
    [EnvironmentName.THETA]: "https://theta-palpatine-back.herokuapp.com/",
    [EnvironmentName.ZETA]: "https://zeta-palpatine-back.herokuapp.com/",
    [EnvironmentName.UMI]: "https://umi-palpatine-back-ae0cfebcffe4.herokuapp.com/",
    [EnvironmentName.HADES]: "https://hades-palpatine-back-75657dfaa5db.herokuapp.com/",
    [EnvironmentName.VOLDEMORT]: "https://voldemort-palpatine-back-be2ed04471de.herokuapp.com/",
};
export const HERMES_ORIGIN: Record<EnvironmentName, string> = {
    [EnvironmentName.PROD]: "https://hermes.prod.aws.waalaxy.com/",
    [EnvironmentName.ALPHA]: "https://alpha-hermes.herokuapp.com/",
    [EnvironmentName.BETA]: "https://beta-hermes.herokuapp.com/",
    [EnvironmentName.CHI]: "https://chi-hermes.herokuapp.com/",
    [EnvironmentName.DELTA]: "https://delta-hermes.herokuapp.com/",
    [EnvironmentName.EPSILON]: "https://epsilon-hermes.herokuapp.com/",
    [EnvironmentName.FAKER]: "https://faker-hermes-61d37da6e601.herokuapp.com/",
    [EnvironmentName.GAMMA]: "https://gamma-hermes.herokuapp.com/",
    [EnvironmentName.IOTA]: "https://iota-hermes.herokuapp.com/",
    [EnvironmentName.KAPPA]: "https://kappa-hermes.herokuapp.com/",
    [EnvironmentName.LAMBDA]: "https://lambda-hermes.herokuapp.com/",
    [EnvironmentName.MU]: "https://mu-hermes.herokuapp.com/",
    [EnvironmentName.NU]: "https://nu-hermes.herokuapp.com/",
    [EnvironmentName.OMEGA]: "https://omega-hermes.herokuapp.com/",
    [EnvironmentName.OMICRON]: "https://omicron-hermes-4f83fdddc83f.herokuapp.com/",
    [EnvironmentName.PSI]: "https://psi-hermes.herokuapp.com/",
    [EnvironmentName.RHO]: "https://rho-hermes.herokuapp.com/",
    [EnvironmentName.SIGMA]: "https://sigma-hermes.herokuapp.com/",
    [EnvironmentName.THETA]: "https://theta-hermes.herokuapp.com/",
    [EnvironmentName.ZETA]: "https://zeta-hermes.herokuapp.com/",
    [EnvironmentName.UMI]: "https://umi-hermes-adf2e04a0505.herokuapp.com/",
    [EnvironmentName.HADES]: "https://hades-hermes-a0babdfe882b.herokuapp.com/",
    [EnvironmentName.VOLDEMORT]: "https://voldemort-hermes-58c1429a957a.herokuapp.com/",
};
export const JANUS_ORIGIN: Record<EnvironmentName, string> = {
    [EnvironmentName.PROD]: "https://janus.prod.aws.waalaxy.com/",
    [EnvironmentName.ALPHA]: "https://alpha-janus.herokuapp.com/",
    [EnvironmentName.BETA]: "https://beta-janus.herokuapp.com/",
    [EnvironmentName.CHI]: "https://chi-janus.herokuapp.com/",
    [EnvironmentName.DELTA]: "https://delta-janus.herokuapp.com/",
    [EnvironmentName.EPSILON]: "https://epsilon-janus.herokuapp.com/",
    [EnvironmentName.FAKER]: "https://faker-janus-43871db3e107.herokuapp.com/",
    [EnvironmentName.GAMMA]: "https://gamma-janus.herokuapp.com/",
    [EnvironmentName.IOTA]: "https://iota-janus.herokuapp.com/",
    [EnvironmentName.KAPPA]: "https://kappa-janus.herokuapp.com/",
    [EnvironmentName.LAMBDA]: "https://lambda-janus.herokuapp.com/",
    [EnvironmentName.MU]: "https://mu-janus.herokuapp.com/",
    [EnvironmentName.NU]: "https://nu-janus.herokuapp.com/",
    [EnvironmentName.OMEGA]: "https://omega-janus.herokuapp.com/",
    [EnvironmentName.OMICRON]: "https://omicron-janus-612c73c3d9df.herokuapp.com/",
    [EnvironmentName.PSI]: "https://psi-janus.herokuapp.com/",
    [EnvironmentName.RHO]: "https://rho-janus.herokuapp.com/",
    [EnvironmentName.SIGMA]: "https://sigma-janus.herokuapp.com/",
    [EnvironmentName.THETA]: "https://theta-janus.herokuapp.com/",
    [EnvironmentName.ZETA]: "https://zeta-janus.herokuapp.com/",
    [EnvironmentName.UMI]: "https://umi-janus-6a2e57f2ae8e.herokuapp.com/",
    [EnvironmentName.HADES]: "https://hades-janus-02b469c20374.herokuapp.com/",
    [EnvironmentName.VOLDEMORT]: "https://voldemort-janus-6542ed1d2aad.herokuapp.com/",
};
